import styled from 'vue-styled-components'
const WidgetHover = styled.div`
pointer-events: all;
position: absolute;
width: fit-content;
padding: 2px 12px 0px;
font-family: 'Roboto';
font-size: 12px;
line-height: 12px;
left: 0;
color: #12A9FF;
background-color: #F4FCFF;
border: 1px solid #ADDFFC;
/* border-radius: 4px 4px 0px 0px; */

&.disabled {
  background-color: #A9A9A9;
  border: 1px solid #A9A9A9;
  color: #FFFFFF;
  border: unset;
}
&.parent-active{
  background: #0B77B5;
  color: #FFFFFF;
  border-radius: 0px;
  border: unset;
}
&.parent-group-active{
  background: #BCC2C7;
  color: #FFFFFF;
  border-radius: 0px;
  border: unset;
  top: 100% !important;
  bottom: unset !important;
  &:hover {
    background-color: #F4FCFF;
    color: #12A9FF;
    cursor: pointer;
  }
}
&.active {
  background-color: #12A9FF;
  border: 1px solid #12A9FF;
  color: #FFFFFF;
  
  button.dropdown-toggle {
    color: #FFFFFF;
  }
}
button.dropdown-toggle {
  color: #12A9FF;
  padding: 0px 10px;
  background: transparent !important;
  border: none !important;
  &.btn-secondary:not(:disabled):not(.disabled):focus {
    &:active {
      background: transparent !important;
      border: none !important;
    }
    &:focus {
      box-shadow: none;
    }
  }
}

ul.dropdown-menu {
  background-color: transparent;
  border: none;
  li {
    background-color: #ADDFFC;
    width: fit-content;
    a {
      color: #0B77B5;
      padding: 2px 6px;
    }
    &:not(:first-child) {
      margin-top: 10px;
    }
  }
}

`
const WrapperProps = {
  position: {}
}
/* pointer-events: none; */
const Wrapper = styled('div', WrapperProps)`
position: absolute;
cursor: pointer;
width: ${({ position }) => position.width};
height: ${({ position }) => position.height};
top: ${({ position }) => position.top};
left: ${({ position }) => position.left};
z-index: 6;

.label-name-frame{
    z-index: 1;
    bottom: 100%;
    white-space: nowrap;
}

&::after {
  position: absolute;
  content: '';
  width: 100%;
  height: 100%;
  border: 1px solid #ADDFFC;
  // background-color: rgba(244,252,255, 0.3);
  z-index: 4;
}
/* border: 3px solid red; */

&.top {
  .lbl-name {
    bottom: 100%;
    border-bottom: 0px;
    white-space: nowrap;
  }
}
&.bottom {
  .lbl-name.header-widget {
    top: 100%;
    border-top: 0px;
    white-space: nowrap;
  }
}
`

export {
  WidgetHover,
  Wrapper
}